import { Page, PageHeader } from "@/components/ui";

/**
 * The page of a tenant that does not exist: a stale bookmark, a mistyped address, a tenant that was
 * deleted since. The server said 404, so the title says so — never the identifier alone, which reads
 * as the NAME of a tenant ("new", "rtl2") — and the identifier is in the subtitle, where a typo shows.
 * The way back leads to the list of tenants (the tenant's own page is the one that is missing). Any
 * other failure to read the tenant keeps its own page: it is not the same news.
 */
export function TenantNotFound({ tenantId, width = "list" }: { tenantId: string; width?: "list" | "form" }) {
  return (
    <Page width={width}>
      <PageHeader
        back={{ to: "/tenants", label: "Tenants" }}
        title="Tenant not found"
        subtitle={
          <>
            No tenant has the identifier <span className="break-all font-mono">{tenantId}</span>.
          </>
        }
      />
    </Page>
  );
}
